import { scaleSqrt } from 'd3-scale'
import { WordCloudConfig, WordCloudWord } from './types'

export const DEFAULT_COLORS = ['#933401', '#E86153', '#D93954', '#AA2417', '#464646']
export const DEFAULT_FONT_SIZE_RANGE: [number, number] = [12, 56]

export interface SizedWord {
  text: string
  count: number
  fontSize: number
  color: string
}

export function sizeWordCloudWords(
  words: WordCloudWord[],
  config: WordCloudConfig,
): SizedWord[] {
  if (!words.length) {
    return []
  }

  const colors = config.colors ?? DEFAULT_COLORS
  const fontSizeRange = config.fontSizeRange ?? DEFAULT_FONT_SIZE_RANGE
  const counts = words.map((word) => word.count)
  const minCount = Math.min(...counts)
  const maxCount = Math.max(...counts)
  const [minFontSize, maxFontSize] = fontSizeRange
  const fontScale =
    minCount === maxCount
      ? () => (minFontSize + maxFontSize) / 2
      : scaleSqrt().domain([minCount, maxCount]).range([minFontSize, maxFontSize])

  return [...words]
    .sort((a, b) => b.count - a.count)
    .map((word, index) => ({
      text: word.text,
      count: word.count,
      fontSize: fontScale(word.count),
      color: colors[index % colors.length],
    }))
}
